export default __webpack_public_path__ + "static/media/ls2_g05.32ccde18.png";